import * as React from "react";
import dayjs from "dayjs";

import { Box, Grid } from "@mui/material";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { IS_HIGHLIGHT_REVIEW_REQUEST_VALIDATION_VALID, HIGHLIGHT_REVIEW_REQUEST_VALIDATION } from "../../../../helper-functions/validation/highlightValidation";

import { getLanguage } from "../../../../config/language/language";
import { HIGHLIGHT_REVIEW_REQUEST_OBJECT, HIGHLIGHT_REVIEW_VOTE_TYPES } from "../../../../config/constants/Constants";

/**
 * A form to update a author.
 */
export default function HighlightReviewEditForm(props) {
    // Because modals don't re-render if the props' state changes, use a callback.
    const { callback, row: existingRow = {} } = props;

    const object = HIGHLIGHT_REVIEW_REQUEST_OBJECT;
    const validation = HIGHLIGHT_REVIEW_REQUEST_VALIDATION;
    const isValid = IS_HIGHLIGHT_REVIEW_REQUEST_VALIDATION_VALID;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    // Initialize the temporary row object with existing values.
    React.useEffect(() => {
        const newRow = {
            ...row,
            ...existingRow,

            // Convert to dayjs format if datetime exists.
            created_on: existingRow.created_on ? dayjs(existingRow.created_on) : null,
            updated_on: existingRow.updated_on ? dayjs(existingRow.updated_on) : null,

            note: existingRow.note || "",
            vote: existingRow.vote || "",

            form: {
                ...row.form,
                ...existingRow.form,
                saved: false // Required to allow editing input fields.
            }
        };

        setInsertObjectState(setRow, newRow);
    }, []);

    /**
     * Executed when typing something into an input field.
     */
    const onChange = (obj, key, value) => {
        const newObj = JSON.parse(JSON.stringify(row));
        setValue(newObj, key, value);

        validateRow(obj, validation, newObj);
        setInsertObjectState(setRow, newObj);
    };

    const handleClick = () => {
        if (!isValid(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }

        const options = { row };
        callback(true, options);
    };

    return (
        <Box className="box">
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomInput name="vote" row={row} onChange={onChange} label="Vote" select={HIGHLIGHT_REVIEW_VOTE_TYPES} />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput name="note" row={row} onChange={onChange} label="Comment" multiline minRows={3} maxRows={5} />
                </Grid>
            </Grid>

            <CustomButton {...props} title={"Update review"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
